// src/users/usersApi.ts
import { apiClient } from "@maat/api-base";
var usersApi = {
  // ── Phone number ─────────────────────────────────────────────────────────
  /** Attach a number, arm a passkey enrollment, or start deletion re-auth. */
  phoneSend: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/phone/send",
      data
    );
  },
  phoneVerify: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/phone/verify",
      data
    );
  },
  // ── Passkeys ─────────────────────────────────────────────────────────────
  passkeys: async () => {
    return await apiClient.get("/main/api/users/me/passkeys");
  },
  /** Where every enrollment entry point lands, except registration (D13). */
  completePasskeyEnrollment: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/passkeys/enrollment/complete",
      data
    );
  },
  /** LOCAL revocation (D14): Maat stops accepting it. The credential still exists at the vendor. */
  revokePasskey: async (id) => {
    return await apiClient.delete(
      `/main/api/users/me/passkeys/${id}`
    );
  },
  /** The step-up primitive. No route consumes its token yet (D12). */
  passkeyStepUpOptions: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/passkeys/step-up/options",
      data
    );
  },
  passkeyStepUpComplete: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/passkeys/step-up/complete",
      data
    );
  },
  updatePreferredCurrency: async (data) => {
    return await apiClient.patch(
      "/main/api/users/me/preferred-currency",
      data
    );
  },
  updateLocale: async (data) => {
    return await apiClient.patch(
      "/main/api/users/me/locale",
      data
    );
  },
  updateProfile: async (data) => {
    return await apiClient.put(
      "/main/api/users/me",
      data
    );
  },
  setPassword: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/password",
      data
    );
  },
  // ── Avatar ───────────────────────────────────────────────────────────────
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return await apiClient.post(
      "/main/api/users/me/avatar",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
  removeAvatar: async () => {
    return await apiClient.delete(
      "/main/api/users/me/avatar"
    );
  },
  // ── Connected accounts (OAuth) ───────────────────────────────────────────
  getLinkedAccounts: async () => {
    return await apiClient.get(
      "/main/api/users/me/oauth-accounts"
    );
  },
  linkOAuthAccount: async (provider, data) => {
    return await apiClient.post(
      `/main/api/users/me/oauth/${provider}/link`,
      data
    );
  },
  unlinkOAuthAccount: async (provider) => {
    return await apiClient.delete(
      `/main/api/users/me/oauth/${provider}`
    );
  },
  // ── MFA (TOTP) ───────────────────────────────────────────────────────────
  initiateMfa: async () => {
    return await apiClient.post("/main/api/users/me/mfa/initiate");
  },
  verifyMfa: async (data) => {
    return await apiClient.post("/main/api/users/me/mfa/verify", data);
  },
  disableMfa: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/mfa/disable",
      data
    );
  },
  getLoginEvents: async () => {
    return await apiClient.get("/main/api/users/me/login-events");
  },
  // ── Admin console (admin_token session) ──────────────────────────────────
  adminListUsers: async (params = {}) => {
    return await apiClient.get("/main/api/admin/users", {
      params
    });
  },
  adminGetUser: async (id) => {
    return await apiClient.get(`/main/api/admin/users/${id}`);
  },
  adminGetUserWorkspaces: async (id) => {
    return await apiClient.get(
      `/main/api/admin/users/${id}/workspaces`
    );
  },
  // ── Impersonation ────────────────────────────────────────────────────────
  impersonateUser: async (data) => {
    return await apiClient.post("/main/api/admin/impersonate", data);
  },
  stopImpersonation: async () => {
    return await apiClient.post(
      // eslint-disable-next-line maat/api-call-scope -- admin impersonation acts on users; there is no standalone impersonation domain
      "/main/api/admin/impersonate/stop"
    );
  }
};

export {
  usersApi
};
